import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import { SlideshowWidget } from "../osoigonext_core/Components/Slideshow.jsx";
import { Post } from "./Components/Post.jsx";

export function RenderPostSlideshow(configuration){
    const container = document.getElementById(configuration.container);
    const postsDataContainer = document.getElementById(configuration.postsJSON);
    const posts = postsDataContainer ? JSON.parse(postsDataContainer.textContent || "[]") : [];
    const root = createRoot(container);
    root.render(
      (
        <SlideshowWidget configuration={configuration}>
          {posts.map((post, idx) => (
            <Post key={`post-${idx}`} post={post} configuration={configuration} />
          ))}
        </SlideshowWidget>
      ),
    );
}

document.addEventListener("DOMContentLoaded", function() {
    const widget_configs = document.querySelectorAll(".post-slideshow-widget-config");

    for (let config of widget_configs) {
        RenderPostSlideshow(JSON.parse(config.innerText));
    }
});
